import _defineProperty from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var nouns = {
  AUDIO_PLAYER: function AUDIO_PLAYER() {
    return "audio player";
  },
  VIDEO_PLAYER: function VIDEO_PLAYER() {
    return "video player";
  },
  VOLUME: function VOLUME() {
    return "volume";
  },
  SEEK: function SEEK() {
    return "seek";
  },
  CLOSED_CAPTIONS: function CLOSED_CAPTIONS() {
    return "closed captions";
  },
  PLAYBACK_RATE: function PLAYBACK_RATE() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$playbackRate = _ref.playbackRate,
        playbackRate = _ref$playbackRate === void 0 ? 1 : _ref$playbackRate;

    return "current playback rate ".concat(playbackRate);
  },
  PLAYBACK_TIME: function PLAYBACK_TIME() {
    return "playback time";
  },
  MEDIA_LOADING: function MEDIA_LOADING() {
    return "media loading";
  }
};
var verbs = {
  PLAY: function PLAY() {
    return "play";
  },
  PAUSE: function PAUSE() {
    return "pause";
  },
  MUTE: function MUTE() {
    return "mute";
  },
  UNMUTE: function UNMUTE() {
    return "unmute";
  },
  ENTER_AIRPLAY: function ENTER_AIRPLAY() {
    return "start airplay";
  },
  EXIT_AIRPLAY: function EXIT_AIRPLAY() {
    return "stop airplay";
  },
  ENTER_CAST: function ENTER_CAST() {
    return "start casting";
  },
  EXIT_CAST: function EXIT_CAST() {
    return "stop casting";
  },
  ENTER_FULLSCREEN: function ENTER_FULLSCREEN() {
    return "enter fullscreen mode";
  },
  EXIT_FULLSCREEN: function EXIT_FULLSCREEN() {
    return "exit fullscreen mode";
  },
  ENTER_PIP: function ENTER_PIP() {
    return "enter picture in picture mode";
  },
  EXIT_PIP: function EXIT_PIP() {
    return "exit picture in picture mode";
  },
  SEEK_FORWARD_N_SECS: function SEEK_FORWARD_N_SECS() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$seekOffset = _ref2.seekOffset,
        seekOffset = _ref2$seekOffset === void 0 ? 30 : _ref2$seekOffset;

    return "seek forward ".concat(seekOffset, " seconds");
  },
  SEEK_BACK_N_SECS: function SEEK_BACK_N_SECS() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$seekOffset = _ref3.seekOffset,
        seekOffset = _ref3$seekOffset === void 0 ? 30 : _ref3$seekOffset;

    return "seek back ".concat(seekOffset, " seconds");
  },
  SEEK_LIVE: function SEEK_LIVE() {
    return "seek to live";
  },
  PLAYING_LIVE: function PLAYING_LIVE() {
    return "playing live";
  }
};

var labels_default = _objectSpread(_objectSpread({}, nouns), verbs);

export { labels_default as default, nouns, verbs };